import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const DeleteConfirmationModal = ({
  show,
  onClose,
  onConfirm,
  message,
  isLoading = false,
}) => {
  const { t } = useTranslation();
  return (
    <Modal show={show} centered onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("Delete Confirmation")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t("Cancel")}
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={isLoading}>
          {t("Delete")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmationModal;
